import { AfterViewInit, Component, ComponentRef, OnInit, OnDestroy, ViewChild, ViewContainerRef, DOCUMENT, DestroyRef, inject, effect } from "@angular/core";
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { IBucketItem, ITags } from "./models/bucket-item.model";
import { Location, NgClass, DatePipe } from "@angular/common";
import { IBreadcrumbItem } from "../../main/layout/tool-bar/model/breadcrumb.model";
import { BucketItemService } from "./service/bucket-item.service";
import { BreadcrumbDataService } from "../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBucketItemRequest } from "./models/bucket-item-request.model";
import { LoaderService, MessageService } from "../../main";
import { CreateFolderComponent } from "./create-folder/create-folder.component";
import { UploadDragAndDropComponent } from "./upload-drag-and-drop/upload-drag-and-drop.component";
import {
  AppSettingsService,
  OverlayPopupRef,
  OverlayPopupService,
  SpinnerService,
} from "../../core";
import { GeneralInformationComponent } from "./general-information/general-information.component";
import {
  ActionConstants,
  BucketTypeConstants,
  CommonConsants,
  ComponentConstants,
  ErrorConstants,
  FolderTypeConstants,
  BucketItemTypeConstants,
} from "./constants/component-constants";
import { TransferItemsComponent } from "./transfer-items/transfer-items.component";
import { ListOverlayComponent } from "./list-overlay/list-overlay.component";
import { DataService } from "./service/data.service";
import { PackageFolder } from "./models/package-folder.model";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { RowDataService } from "./service/row-data.service";
import { catchError, EMPTY, finalize, map, Observable, Subject, switchMap, take, throwError } from "rxjs";
import {
  IDownloadItem
} from "./models/download-item.model";
import { RenamePopupComponent } from "./rename-popup/rename-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { IRenameFolderPopUp } from "./models/rename-folder-popup.model";
import { MoveItemsComponent } from "./move-items/move-items.component";
import { IDeleteFolderPopUp } from "./models/delete-folder-popup.model";
import { DeletePopupComponent } from "./delete-popup/delete-popup.component";
import { FileVersionHistoryComponent } from "./file-version-history/file-version-history.component";
import { SearchComponent } from "../../shared/search/search.component";
import { ISearchRequest } from "../models/searchRequest.model";
import { MultipleTagsComponent } from "./multiple-tags/multiple-tags.component";
import { PackageFolderTagsComponent } from "./package-folder-tags/package-folder-tags.component";
import { ISearchResultsResponse } from "./models/search-results-response.model";
import { IBucketItemsResponse } from "./models/bucket-items-response.model";
import { JustificationDialogComponent } from "../../shared/justification-dialog/justification-dialog.component";
import { GenericExtensionsService } from "../../extensions/generic-extensions-service";
import { FolderPermissionComponent } from "../requester-access/folder-permission/folder-permission.component";
import { IExportContentListRequest } from "./models/export-content-list-request.model";
import { Sort, MatSort, MatSortHeader } from "@angular/material/sort";
import { IUserInformation } from "../../shared/user-information-overlay/user-information";
import { ISortParameters } from "./models/sort-parameters.model";
import { TemplateComponent } from "./template/template.component";
import { BucketDataService } from "../service/bucket-data.service";
import { BucketList } from "../buckets/models/bucket.model";
import { SectionTitleComponent } from "../../shared/section-title/section-title.component";
import { MatTooltip } from "@angular/material/tooltip";
import { MatDivider } from "@angular/material/divider";
import { NoDocumentFoundComponent } from "../../shared/no-document-found/no-document-found.component";
import { LazyScrollDirective } from "../../directives/lazy-scroll.directive";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatCheckbox } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { ResizeColumnDirective } from "../../directives/resize-column.directive";
import { TooltipDisableDirective } from "../../shared/custom-directives/tooltip.directive";
import { EllipsisLeftDirective } from "../../directives/ellipsis-left.directive";
import { MatIconButton } from "@angular/material/button";
import { MatRippleDirective } from "../../shared/custom-directives/matRipple.directive";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { HasDisplayIconsDirective } from "./display-icons/has-display-icons.directive";

@Component({
    selector: "app-bucket-items",
    templateUrl: "./bucket-items.component.html",
    styleUrls: ["./bucket-items.component.scss"],
    imports: [SectionTitleComponent, MatTooltip, MatDivider, SearchComponent, NoDocumentFoundComponent, NgClass, LazyScrollDirective, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, FormsModule, MatSortHeader, ResizeColumnDirective, TooltipDisableDirective, EllipsisLeftDirective, MatIconButton, MatRippleDirective, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatProgressSpinner, HasDisplayIconsDirective, DatePipe]
})
export class BucketItemsComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly location = inject(Location);
  private readonly bucketItemsService = inject(BucketItemService);
  private readonly breadcrumbDataService = inject(BreadcrumbDataService);
  private readonly loader = inject(LoaderService);
  private readonly overlayPopupService = inject(OverlayPopupService);
  private readonly messageService = inject(MessageService);
  private readonly appSettingService = inject(AppSettingsService);
  private readonly dataService = inject(DataService);
  private readonly spinnerService = inject(SpinnerService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly rowDataService = inject(RowDataService);
  private readonly dialog = inject(MatDialog);
  private readonly genericExtensions = inject(GenericExtensionsService);
  private readonly bucketDataService = inject(BucketDataService);
  private readonly _document = inject<Document>(DOCUMENT);

  public selectedPackageData: Partial<IBucketItem>;
  rightPanelCollapsed: boolean;
  bucketItems: Partial<IBucketItem>[] = [];
  displayBucketItems: Partial<IBucketItem>[] = [];
  public columnList: string[] = [
    "select",
    "ItemType",
    "Name",
    "Tags",
    "Created By",
    "Created On",
    "icon-column",
  ];
  public searchColumnList: string[] = [
    "ItemType",
    "Name",
    "Path",
    "Tags",
    "Created By",
    "Created On",
    "Download",
  ];
  public allItemsChecked: boolean = false;
  public displayTransfer: boolean = false;
  public displayCreateFolderInPreArchive: boolean = false;
  public displayFolderPermission: boolean = false;
  public displayExportContent: boolean = false;
  public buCode: string = "";
  public checksum_fail_tooltip = CommonConsants.CHECKSUM_FAIL_TOOLTIP;
  public bucketType: string = "";
  public title: string = "";
  @ViewChild("dynamic", { static: true, read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public hoverindex = "";
  public currentBreadcrumbItem: Partial<IBreadcrumbItem> = {};
  public clickedRow: string;
  public preserveTransferItems: Partial<IBucketItem>[] = [];
  public checkedPackageData: Partial<IBucketItem>[] = [];
  public itemList: string[] = [];
  private kebabContextItem: Partial<IBucketItem> | null = null;
  public displayRename: boolean = false;
  public displayDownload: boolean = false;
  public displayMove: boolean = false;
  public displayDelete: boolean = false;
  public displayTags: boolean = false;
  public displayExportAuditTrail: boolean = false;
  public singleSelection: boolean = false;
  public multiSelection: boolean = false;
  public downloadItem: Partial<IDownloadItem> = {};
  public exportContent: Partial<IExportContentListRequest> = {};
  public selectedBucketItems: Partial<IBucketItem>[] = [];
  public renameFolderPopup: IRenameFolderPopUp;
  public checkedBuckets: string[];
  public permissionList: string[];
  public deleteFolderPopup: IDeleteFolderPopUp;
  isActive: string = "General Information";
  public showGlobalCheckbox: boolean = false;
  @ViewChild(SearchComponent, { static: true }) searchComponent: SearchComponent;
  public isSearchable: boolean = false;
  searchExpand: boolean = false;
  public searchRequest: Partial<ISearchRequest> = {};
  public static BuCode: string = "";
  public static BucketType: string = "";
  public highlightRow: string = "";
  public searchResults: Partial<ISearchResultsResponse> = {};
  public IsSearched: boolean = false;
  public clearSearch: boolean = false;
  public fromGlobalSearch: boolean = false;
  public pageNumber: number = 1;
  public count: number = 0;
  public static requestedAccess: boolean = false;
  public checkedBucketItemsForMulipleTags: string[];
  public navigationFromFolder: boolean = false;
  public lastNavigatedItem: string = "";
  public scrollable: boolean = true;
  public searchResetCounter: number = 0;
  public readonly pendingOperations: Set<string> = new Set();
  private readonly destroyRef = inject(DestroyRef);
  private readonly _checkBoxTransferData = toSignal(this.dataService.getCheckBoxTransferData());
  private readonly _clearSearch = toSignal(this.dataService.getClearSearch());
  private readonly _pageNo = toSignal(this.dataService.getPageNo());
  private readonly _autoCompleteStatus = toSignal(this.dataService.getAutoCompleteActiveStatus(), { initialValue: false });
  private readonly searchTrigger$ = new Subject<number>();
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "list";
  private skipClearSearchReload = false;
  public baseAppUrl: string;
  public bucketDataList: Partial<BucketList>[] = [];
  public readonly bucketList = toSignal(
    this.bucketDataService.getBucketData(),
    { initialValue: [] as BucketList[] }
  );
  public isOnlyPackageFolders: boolean = false;
  public browseTotalPages: number = 0;
  public browsePageNumber: number = 1;
  private currentBrowseRequest: Partial<IBucketItemRequest> = {};
  public totalNumberOfFiles: number = 0;
  private bucketItemsRequestCounter = 0;

  constructor() {
    this.selectedPackageData = new PackageFolder();
    this.searchResults.BucketItems = [];
    this.IsSearched = false;
    this.baseAppUrl = this._document.location.origin;
    effect(() => {
      const data = this._checkBoxTransferData();
      if (data == null) return;
      if (data.length > 0) {
        this.checkedBuckets = [];
        this.checkedBuckets = data.map((x) => x.Id!);
        this.bucketItems.forEach((item) => {
          if (this.checkedBuckets.includes(item.Id!)) {
            item.IsChecked = true;
          } else {
            item.IsChecked = false;
          }
        });
        this.updateCheckBoxes();
      } else if (data.length === 0) {
        this.bucketItems.forEach((item) => {
          item.IsChecked = false;
        });
        this.updateCheckBoxes();
        this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
      }
    });
    effect(() => {
      const data = this._clearSearch();
      if (data) {
        this.clearSearch = data;
        this.searchResults.BucketItems = [];
        this.IsSearched = false;
        this.pageNumber = 1;
        if (!this.skipClearSearchReload) {
          this.getAllBucketItems(this.currentBrowseRequest, undefined, true, 1);
        }

        this.skipClearSearchReload = false;
        this.searchResetCounter++;
        this._document.getElementById('bucket-items-list-cnt-virtual-scroll')?.scrollTo({ top: 0 });
        this.dataService.setClearSearch(false);
      }
    });
    effect(() => {
      const data = this._pageNo();
      if (data) {
        this.search(data);
      }
    });
    effect(() => {
      this.scrollable = !this._autoCompleteStatus();
    });
  }

  get hasMorePages(): boolean {
    return this.IsSearched
      ? this.pageNumber < (this.searchResults.TotalPages ?? 0)
      : this.browsePageNumber < this.browseTotalPages;
  }

  ngOnInit(): void {
    this.loader.setRootViewContainerRef(this.viewContainerRef);
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
      this.pageNumber = 1;
      this.currentBreadcrumbItem = {
        BucketId: x.bucketId,
        BucketType: x.bucketType,
        BUCode: x.buCode,
        EleName: x.eleName ?? '',
        DirectoryName: x.directoryName,
        ParentId: undefined,
        PackageId: x.packageId,
      };
      this.getAllBucketItems(
        {
          BucketId: x.bucketId,
          BucketType: x.bucketType,
          BUCode: x.buCode,
          DirectoryName: x.directoryName,
          PackageId: x.packageId,
        },
        undefined,
        true
      );
    });
    BucketItemsComponent.BuCode = this.currentBreadcrumbItem.BUCode ?? '';
    BucketItemsComponent.BucketType = this.currentBreadcrumbItem.BucketType ?? '';
    this.highlightRow = this._document.defaultView?.localStorage.getItem('highlightRow') ?? '';
    this.clickedRow = this.highlightRow;
    if (this.highlightRow) {
      this.fromGlobalSearch = true;
    }
    this._document.defaultView?.localStorage.setItem('highlightRow', '');
    this.searchResults.BucketItems = [];
    this.searchTrigger$.pipe(
      switchMap(pageNumber => this.executeSearch(pageNumber)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.searchTrigger$.complete();
    BucketItemsComponent.BucketType = "";
    this.pendingOperations.clear();
    this.spinnerService.show(false);
  }

  ngAfterViewInit(): void {
    this.spinnerService.show(true);
  }

  private addPendingOperation(operationName: string): void {
    this.pendingOperations.add(operationName);
    this.spinnerService.show(true);
  }

  private completePendingOperation(operationName: string): void {
    const hadOperations = this.pendingOperations.size > 0;
    this.pendingOperations.delete(operationName);
    if (hadOperations && this.pendingOperations.size === 0) {
      this.spinnerService.show(false);
    }
  }

  sortData(sortData: Sort) {
    this.getAllBucketItems(
      {
        BucketId: this.currentBreadcrumbItem.BucketId,
        BucketType: this.currentBreadcrumbItem.BucketType,
        BUCode: this.currentBreadcrumbItem.BUCode,
        DirectoryName: this.currentBreadcrumbItem.DirectoryName,
        PackageId: this.currentBreadcrumbItem.PackageId,
        Sort: { Column: sortData.active, Direction: sortData.direction }
      }
    );
  }

onSortChange(sortData: Sort) {
  if (this.IsSearched) {
    this.searchRequest.Sort = { Column: sortData.active, Direction: sortData.direction };
    this.pageNumber = 1;
    this.search(1);
  } else {
    this.sortData(sortData);
  }
}

  public getAllBucketItems(
    bucketItemRequest: Partial<IBucketItemRequest>,
    bucketItemId: string | undefined = undefined,
    resetAction: boolean = false,
    pageNumber: number = 1
  ): void {
    const isFirstPage = pageNumber === 1;
    const requestToken = `getBucketItems-${++this.bucketItemsRequestCounter}`;

    if (isFirstPage) {
      this.browsePageNumber = 1;
      this.browseTotalPages = 0;
      this.currentBrowseRequest = bucketItemRequest;
      this.searchResetCounter++;
    }

    if (isFirstPage) {
      this.addPendingOperation(requestToken);
    } else {
      this.pendingOperations.add(requestToken);
    }

    if (
      (this.bucketItems.filter((x) => x.IsChecked).length === 0 ||
      resetAction) && isFirstPage
    ) {
      this.resetActions();
    }
    this.bucketItemsService.GetBucketItems(bucketItemRequest, pageNumber).subscribe({
      next: (res: IBucketItemsResponse) => {
      this.IsSearched = false;
      this.browseTotalPages = res.TotalPages ?? 0;
      this.browsePageNumber = pageNumber;

      if (isFirstPage) {
        this.permissionList = res.PermissionsList;
        this.dataService.setPermissionList(this.permissionList || []);
        this.allItemsChecked = false;
        this.title = (bucketItemRequest.DirectoryName ?? '').split("/").slice(-1)[0];
      }

      const newItems = res.BucketItems ?? [];
      newItems.forEach((bucketItem) => {
        bucketItem.TagsWithValues = bucketItem.Tags?.filter(
          (x) => x.TagValue !== ""
        ) || [];
      });

      if (isFirstPage) {
        this.bucketItems = newItems;
      } else {
        this.bucketItems = [...this.bucketItems, ...newItems];
      }

      this.count = res.TotalCount ?? this.bucketItems.length;
      this.totalNumberOfFiles = res.TotalFileCount ?? this.bucketItems.filter(x => x.Type === BucketItemTypeConstants.FILE).length;
      this.displayBucketItems = this.bucketItems;
        this.dataService.setDataForBucketItems(this.bucketItems);

      if (isFirstPage) {
        let breadCrumbItem: Partial<IBreadcrumbItem> = {
          BucketId: bucketItemRequest.BucketId,
          BucketType: bucketItemRequest.BucketType,
          BUCode: bucketItemRequest.BUCode,
          EleName: this.currentBreadcrumbItem.EleName,
          DirectoryName: bucketItemRequest.DirectoryName,
          ParentId: res.ParentId,
          PackageId: res.PackageId,
        };

        this.displayCreateFolderInPreArchive = false;
        if (breadCrumbItem.BucketType === BucketTypeConstants.PREARCHIVE && breadCrumbItem.ParentId === null) {
          this.displayCreateFolderInPreArchive = true;
        }
        this.showGlobalCheckbox =
          (bucketItemRequest.DirectoryName ?? '').split("/").length > 2;
        this.currentBreadcrumbItem = breadCrumbItem;
        this.breadcrumbDataService.setBreadcrumbItem(breadCrumbItem);
        if (this.fromGlobalSearch) {
          if (this.bucketItems.length > 0) {
            this.rowDataService.setclickedRowData(this.bucketItems.find(x => x.Id === this.clickedRow) ?? null);
          } else {
            this.rowDataService.setclickedRowData(null);
          }
          this.fromGlobalSearch = false;
        }
        else {
          if (this.bucketItems.length > 0) {
            if (this.bucketItems.some(x => x.Id === this.clickedRow)) {
              this.rowDataService.setclickedRowData(this.bucketItems.find(x => x.Id === this.clickedRow) ?? null);
            }
            else {
              this.clickedRow = this.bucketItems[0].Id!;
              this.rowDataService.setclickedRowData(this.bucketItems[0]);
            }
          } else {
            this.rowDataService.setclickedRowData(null);
          }
        }
        if (bucketItemId) {
          this.addPendingOperation('packageFolders');
          this.bucketItems.forEach((item) => {
            item.IsChecked = this.checkedBuckets?.includes(item.Id!);
          });
          this.dataService.getPackageFolders().subscribe((data: string[]) => {
            if (data.find((x) => x === bucketItemId)) {
              this.bucketItems.map((x) => {
                if (data.some((e) => e === x.Id)) {
                  x.IsChecked = true;
                  x.IsConsideredForTransfer = x.StudyCompletionDate
                    ? false
                    : true;
                }
              });
            }
            this.completePendingOperation('packageFolders');
          });
        }

        if (this.checkedBucketItemsForMulipleTags) {
          this.bucketItems.forEach((item) => {
            if (this.checkedBucketItemsForMulipleTags.includes(item.Id!)) {
              item.IsChecked = true;
            } else {
              item.IsChecked = false;
            }
          });
          this.updateCheckBoxes();
          this.checkedBucketItemsForMulipleTags = [];
        }
        this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
        this.ScrollToItem();
      }
        
        this.completePendingOperation(requestToken);
      },
      error: (error: HttpErrorResponse) => {
        if (error?.error?.detail.includes(ErrorConstants.NOT_AUTHORIZED)) {
          let breadCrumbItem: Partial<IBreadcrumbItem> = {
            BucketId: bucketItemRequest.BucketId,
            BucketType: bucketItemRequest.BucketType,
            BUCode: bucketItemRequest.BUCode,
            EleName: this.currentBreadcrumbItem.EleName,
            DirectoryName: bucketItemRequest.DirectoryName,
            PackageId: this.currentBreadcrumbItem.PackageId,
            ParentId: this.clickedRow
          };
          if (this.navigationFromFolder) {
            this.goBack();
            this.navigationFromFolder = false;
            breadCrumbItem.ParentId = this.lastNavigatedItem;
          }
          this.title = (bucketItemRequest.DirectoryName ?? '').split("/").slice(-1)[0];
          this.bucketItems = [];
          this.count = 0;
          this.displayBucketItems = this.bucketItems;
          this.dataService.setDataForBucketItems(this.bucketItems);

          this.currentBreadcrumbItem = breadCrumbItem;
          this.breadcrumbDataService.setBreadcrumbItem(breadCrumbItem);
          this.loadDynamicComponent('');
        }
        if (error.error.detail) {
          this.messageService.alert(
            error.error.detail,
            this.appSettingService.toastrDisplayTime
          );
        } else {
          this.messageService.alert(
            error.error.message,
            this.appSettingService.toastrDisplayTime
          );
        }

        this.completePendingOperation(requestToken);
      },
    });
  }

  public getBucketDisplayName(bucketName: string): string {
    return this.genericExtensions.getBucketDisplayName(bucketName);
  }

  public getDisplayCountText(): string {
    if (this.IsSearched) {
      return `${this.searchResults.TotalCount ?? 0} Results`;
    }
    if (this.isPackageLevel()) {
      return `${this.count} Items`;
    }
    return `${this.count} Items | ${this.totalNumberOfFiles} Files in Total`;
  }

  public isPackageLevel(): boolean {
    return this.currentBreadcrumbItem?.DirectoryName?.split("/").length === 2;
  }

  public navigateToPendingJustifications(item: Partial<IBucketItem>): void {
    const packageName = item.LeafName ?? '';
    const bucketId = item.BucketId ?? this.currentBreadcrumbItem.BucketId ?? '';
    const buCode = this.currentBreadcrumbItem.BucketType === BucketTypeConstants.STUDYDATACOLLECTION
      ? ComponentConstants.BU_GLOBAL
      : (this.currentBreadcrumbItem.BUCode ?? '');
    const bucketType = this.currentBreadcrumbItem.BucketType ?? BucketTypeConstants.STUDYDATACOLLECTION;
    this.router.navigate([`/automated-transfers/<${packageName}><${bucketId}><${buCode}><${bucketType}>`]);
  }

  public ScrollToItem() {
    this.addPendingOperation('scrollToItem');
    setTimeout(() => {
      let elements = this._document.querySelectorAll('.emptyCss');
      elements.forEach((node: Element) => {
        if ((node as HTMLElement).classList.contains('highlightRowSearch')) {
          (node as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
      });
      this.completePendingOperation('scrollToItem');
    }, 1000);
  }

  public setAll(checked: boolean) {
    this.allItemsChecked = checked;
    if (this.bucketItems && this.bucketItems.length > 0) {
      this.bucketItems.forEach((item) => (item.IsChecked = checked));
    }
    this.updateCheckBoxes();
  }

  public uncheckAll(checked: boolean) {
    this.allItemsChecked = false;
    if (this.bucketItems && this.bucketItems.length > 0) {
      this.bucketItems.forEach((item) => (item.IsChecked = checked));
      this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
    }
  }

  public updateCheckBoxes() {
    this.internalUpdateCheckBoxes();
  }

  public onRowCheckboxClick(item: Partial<IBucketItem>): void {
    item.IsChecked = !item.IsChecked; // Toggle selection
    this.internalUpdateCheckBoxes(item);
  }

  private internalUpdateCheckBoxes(lastChangedItem?: Partial<IBucketItem>) {
    this.allItemsChecked =
      this.bucketItems && this.bucketItems.every((item) => item.IsChecked);
    this.removehighlightForPackageFolderSelectedForTransfer();
    this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
    this.dataService.setPackageFolders([]);
    this.checkedPackageData = this.bucketItems.filter(
      (x) => x.IsChecked === true
    );
    this.checkedBuckets = this.checkedPackageData.map((x) => x.Id!);
    const selectionCount = this.checkedPackageData.length;

    if (selectionCount === 0) {
      this.resetActions();
      // Auto-highlight first row when nothing selected (Requirement 3)
      if (this.bucketItems?.length > 0) {
        const first = this.bucketItems[0];
        if (this.clickedRow !== first.Id) {
          this.clickedRow = first.Id!;
          this.rowDataService.setclickedRowData(first);
          this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
        }
      }
    } else if (selectionCount === 1) {
      this.itemList = [];
      this.singleSelection = true;
      this.multiSelection = false;
      const only = this.checkedPackageData[0];
      if (this.clickedRow !== only.Id) {
        this.clickedRow = only.Id!; // Highlight sole selected row (Req 1 & 2)
        this.rowDataService.setclickedRowData(only);
        this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
      }
      let types: string[] = [only.Type!];
      this.addActionsBasedOnItemType(types);
    } else {
      this.singleSelection = false;
      this.multiSelection = true;
      this.resetActions();
      let types = this.checkedPackageData.map((x) => x.Type!);
      this.addActionsBasedOnItemType(types);
      let target: Partial<IBucketItem> | null = null;
      if (lastChangedItem && lastChangedItem.IsChecked) {
        target = lastChangedItem;
      } else if (!this.checkedPackageData.some(x => x.Id === this.clickedRow)) {
        target = this.checkedPackageData[this.checkedPackageData.length - 1];
      }
      if (target) {
        this.clickedRow = target.Id!;
        this.rowDataService.setclickedRowData(target);
        this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
      }
    }
  }

  removehighlightForPackageFolderSelectedForTransfer(): void {
    this.bucketItems.forEach((x) => {
      if (!x.IsChecked) x.IsConsideredForTransfer = false;
    });
  }

  public someChecked(): boolean {
    if (this.bucketItems === null) {
      return false;
    }
    return (
      this.bucketItems.filter((t) => t.IsChecked).length > 0 &&
      !this.allItemsChecked
    );
  }

  public navigateToFolder(item: Partial<IBucketItem>) {
    this.dataService.setClearSearch(true);
    this.navigationFromFolder = true;
    this.lastNavigatedItem = item.Id!;
    this.uncheckAll(false);
    this.router.navigate([`/buckets/bucketitem`], {
      queryParams: {
        bucketId: this.currentBreadcrumbItem.BucketId,
        bucketType: this.currentBreadcrumbItem.BucketType,
        buCode: this.currentBreadcrumbItem.BUCode,
        eleName: this.currentBreadcrumbItem.EleName,
        directoryName: `${this.currentBreadcrumbItem.DirectoryName}/${item.LeafName}`,
        packageId: item.PackageId,
      },
    });
  }

  public goBack(): void {
    this.dataService.setClearSearch(true);
    this.uncheckAll(false);
    this.location.back();
  }

  openUploadDragAndDrop() {
    this.isActive = "FileFolder Upload";
      let dialogRef = this.dialog.open(UploadDragAndDropComponent, {
        panelClass: "upload-drag-drop-panel",
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((res: boolean) => {
        if (res) {
          this.getAllBucketItems(
            {
              BucketId: this.currentBreadcrumbItem.BucketId,
              BucketType: this.currentBreadcrumbItem.BucketType,
              BUCode: this.currentBreadcrumbItem.BUCode,
              DirectoryName: this.currentBreadcrumbItem.DirectoryName,
              PackageId: this.currentBreadcrumbItem.PackageId,
            },
            undefined,
            true
          );
        }
      });
  }

  private getFilenameFromContentDisposition(
    contentDisposition: string
  ): string {
    const regex = /filename=(?<filename>[^,;]+);/g;
    const match = regex.exec(contentDisposition);
    return match?.groups?.filename?.replace(/"/g, "") ?? "download";
  }

 public async downloadBucketItem(item?: Partial<IBucketItem>): Promise<void> {
    this.spinnerService.show(true);

    if (item) {
      const buCodeFromDir = item.DirName?.split("/")[0] === "Global" ? "" : item.DirName?.split("/")[0];
      const bucketTypeFromDir = (item.DirName?.split("/")[1] || this.bucketType || "").replace(/-/g, "");
      this.downloadItem.BucketId = item.BucketId;
      this.downloadItem.BucketType = bucketTypeFromDir;
      this.downloadItem.BuCode = buCodeFromDir;
      this.downloadItem.BucketItemIds = [item.Id!];
      this.downloadItem.PackageId = item.PackageId;
    } else {
      const selectedItems = this.bucketItems.filter((t) => t.IsChecked);
      this.downloadItem.BucketId = this.currentBreadcrumbItem.BucketId;
      this.downloadItem.BucketType = this.currentBreadcrumbItem.BucketType;
      this.downloadItem.BuCode = this.currentBreadcrumbItem.BUCode;
      this.downloadItem.BucketItemIds = [];
      this.downloadItem.PackageId = "";

      selectedItems.forEach((a) => {
        this.downloadItem.BucketItemIds!.push(a.Id!);
        if (!this.downloadItem.PackageId) {
          this.downloadItem.PackageId = a.PackageId;
        }
      });
    }

      this.bucketItemsService
        .downloadBucketItem(this.downloadItem)
        .pipe(
          map((data: any) => {
            if (data) {
              // Existing justification dialog logic
              if (data.body.type === "application/json") {
                this.blobToJson(data.body).then((jsonData) => {
                this.spinnerService.show(false);
                    if (jsonData.statusMessage) {
                      return this.messageService.success(jsonData.statusMessage, this.appSettingService.toastrDisplayTime);
                    }
                this.dialog.open(JustificationDialogComponent, {
                  width: "450px",
                  disableClose: true
                }).afterClosed().subscribe(
                  (response: { comment: string }) => {
                    if (response?.comment) {
                      this.downloadItem.Comment = response.comment;
                      this.downloadBucketItem(item);
                    }              
                  }
                );
                });     
              } else {
                this.spinnerService.show(false);
                const comment = this.downloadItem.Comment;
                this.downloadItem.Comment = undefined;
                const contentDisposition = data.headers.get("Content-Disposition");
                const completeFileName =
                  this.getFilenameFromContentDisposition(contentDisposition);
                const parts = completeFileName.split('\\\\');
                const maliciousFlag = parts[0];
                let filename = parts[1];
                filename = this.genericExtensions.extractBase64AndDecode(filename);
                if (maliciousFlag === "True") {
                  this.messageService.warning(
                    ErrorConstants.MALICIOUS_WARNING,
                    this.appSettingService.toastrDisplayTime
                  );
                }
                const blob = new Blob([data.body], {
                  type: "application/zip",
                });
                const a: any = this._document.createElement("a");
                const url = this._document.defaultView!.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                a.click();
                this._document.defaultView!.URL.revokeObjectURL(url);
                const folderType = parseInt(data.headers.get("X-Folder-Type") ?? "0", 10);
                this.bucketItemsService.downloadAuditTrailEntry({
                  BucketItemIds: this.downloadItem.BucketItemIds!,
                  PackageId: this.downloadItem.PackageId!,
                  Comment: comment,
                  FolderType: folderType,
                }).subscribe();
              }
            } else {
              this.spinnerService.show(false);
            }
            this.downloadItem.Comment = undefined;
          }),
          catchError(async (error: HttpErrorResponse) => {
            this.spinnerService.show(false);
            this.downloadItem.Comment = undefined;
            try {
              const errorMessage = JSON.parse(await error.error.text());
              if (errorMessage.detail) {
                if (
                  errorMessage.detail.toString().startsWith(
                    ErrorConstants.DOWNLOAD_SIZE_REACHED
                  ) || errorMessage.detail.toString().startsWith(ErrorConstants.MAX_DOWNLOAD_FOR_LARGE_FILE)
                ) {
                  this.messageService.confirm(
                    this.formatMessage(errorMessage.detail),
                    ErrorConstants.MAX_DOWNLOAD_LIMIT,
                    "",
                    "OK",
                    false
                  );
                } else if (
                  errorMessage.detail.toString().startsWith(
                    ErrorConstants.MALICIOUS_WARNING
                  )
                ) {
                  this.messageService.warning(
                    ErrorConstants.MALICIOUS_WARNING,
                    this.appSettingService.toastrDisplayTime
                  );
                } else {
                  this.messageService.alert(
                    errorMessage.detail,
                    this.appSettingService.toastrDisplayTime
                  );
                }
              } else {
                this.messageService.alert(
                  ErrorConstants.DOWNLOAD_FAILED,
                  this.appSettingService.toastrDisplayTime
                );
              }
            } catch (parseError) {
              this.messageService.alert(
                ErrorConstants.DOWNLOAD_FAILED,
                this.appSettingService.toastrDisplayTime
              );
            }
            return throwError(() => new Error(error.message || 'Download failed'));
          })
        )
        .subscribe();
  }

  public onRowClick(row: any) {
    this.clickedRow = row.Id;
    this.rowDataService.setclickedRowData(row);
    let componentRef: ComponentRef<any>;
    this.viewContainerRef.clear();
    componentRef = this.viewContainerRef.createComponent(GeneralInformationComponent);
    componentRef.instance.isFromSearch = true;
  }

  public navigateToSearchResultFolder(event: Event, res: Partial<IBucketItem>) {
    let buCode = res.DirName!.split("/")[0];
    let bucketType = res.DirName!.split("/")[1];
    this.breadcrumbDataService
      .getCurrentBreadCrumbItem()
      .pipe(take(1))
      .subscribe((item: Partial<IBreadcrumbItem>) => {
        this.currentBreadcrumbItem = item;
      });
    this.bucketDataService.getBucketData().pipe(take(1)).subscribe((data: Partial<BucketList>[]) => {
      this.bucketDataList = data;
    });
    let bucketData = this.bucketDataList.find(x => x.BUCode != '' && x.BUCode === buCode)
    let eleName = bucketData ? bucketData.EleName : null;
    let link = this.buildPathForSearchResult(res.BucketId!, bucketType, buCode, eleName!, res.DirName!, res.PackageId!, res.Type!);
    this._document.defaultView?.localStorage.setItem("highlightRow", res.Id!);
    this._document.defaultView!.open(link, "_blank");
    event.preventDefault();
    event.stopPropagation();
  }

  private buildPathForSearchResult(bucketId: string, bucketType: string, buCode: string, eleName: string, directoryName: string, packageId: string, type: string): string {
    let addBuCode = buCode === "Global" ? "" : buCode;
    const addDirectory = encodeURIComponent(directoryName);
    let urlPath: string = `${this.baseAppUrl}/#/buckets/bucketitem?bucketId=${bucketId}&bucketType=${bucketType.replace("-", "")}&buCode=${addBuCode}&eleName=${encodeURIComponent(eleName)}&directoryName=${addDirectory}`;

    return type === 'Folder' ? urlPath : `${urlPath}&packageId=${packageId}`;
  }

  public formatMessage(message: string): any {
    let formattedTxtArr = message.split('"');
    formattedTxtArr[1] = `<span class="blue-text">${formattedTxtArr[1]}</span>`;
    const parts = formattedTxtArr[3].split(" ");
    const numberPart = parts[0];
    const ellipsisNumber = numberPart.slice(0, 4) + "...";
    const formattedText = ellipsisNumber + " " + parts.slice(1).join(" ");
    formattedTxtArr[3] = `<span class="red-text tooltip-confirm-popup ">${formattedText}
                          <span class="tooltiptext-confirm-popup font-s radius-4">${formattedTxtArr[3]}</span>
                          </span>`
    return formattedTxtArr.join('"');
  }

  public loadDynamicComponent(component: string) {
    this.viewContainerRef.clear();
    this.isActive = component;
    let componentRef: ComponentRef<any>;
    switch (component) {
      case ComponentConstants.CREATE_FOLDER:
        componentRef = this.viewContainerRef.createComponent(
          CreateFolderComponent
        );
        componentRef.instance.getAllBucketItemsRequest.subscribe(
          (request: IBucketItemRequest) => {
            this.getAllBucketItems(request);

            if (this.bucketItems?.length > 0) {
              this.clickedRow = this.bucketItems[0].Id!;
              this.rowDataService.setclickedRowData(this.bucketItems[0]);
            } else {
              this.rowDataService.setclickedRowData(null);
            }
            this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          }
        );

        break;

      case ComponentConstants.FOLDER_PERMISSION:
        componentRef = this.viewContainerRef.createComponent(
          FolderPermissionComponent
        );
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
        componentRef.instance.accessGiven.subscribe((result: boolean) => {
          if (result) {
            this.uncheckAll(false);
            this.resetActions();
            BucketItemsComponent.requestedAccess = true;
            this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          }
        });
        break;

        case ComponentConstants.TEMPLATES:
          componentRef = this.viewContainerRef.createComponent(
            TemplateComponent
          );
          componentRef.instance.getAllBucketItemsRequest.subscribe(
            (request: IBucketItemRequest) => {
              this.getAllBucketItems(request, undefined, true);
            }
          );
          break;

      case ComponentConstants.TRANSFER_PACKAGE:
        if (this.bucketItems?.length === 0) {
          this.messageService.alert(
            ErrorConstants.SELECT_OR_CREATE_FOLDER,
            this.appSettingService.toastrDisplayTime
          );
        }
        componentRef = this.viewContainerRef.createComponent(
          TransferItemsComponent
        );
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));

        componentRef.instance.cancelTransfer.subscribe((result: boolean) => {
          if (result) {
            this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          }
        });
        componentRef.instance.getAllBucketItemsRequest.subscribe(
          (request: IBucketItemRequest) => {
            this.dataService.setData(
              this.bucketItems.filter((t) => t.IsChecked)
            );
            this.getAllBucketItems(request, undefined, true);
          }
        );
        break;

      case ComponentConstants.GENERAL_INFORMATION:
        componentRef = this.viewContainerRef.createComponent(
          GeneralInformationComponent
        );
        componentRef.instance.updateTagsFlag.subscribe((res: boolean) => {
          if (res) {
            this.uncheckAll(false);
            this.getAllBucketItems(
              {
                BucketId: this.currentBreadcrumbItem.BucketId,
                BucketType: this.currentBreadcrumbItem.BucketType,
                BUCode: this.currentBreadcrumbItem.BUCode,
                DirectoryName: this.currentBreadcrumbItem.DirectoryName,
                PackageId: this.currentBreadcrumbItem.PackageId,
              }
            );
          }
        });
        componentRef.instance.bucketItem.subscribe((res: boolean) => {
          if (res) {
            let bucketItemId = "";
            this.rowDataService
              .getClickedRowData()
              .pipe(take(1))
              .subscribe((res) => { if (res?.Id) bucketItemId = res.Id; });
            this.getAllBucketItems(
              {
                BucketId: this.currentBreadcrumbItem.BucketId,
                BucketType: this.currentBreadcrumbItem.BucketType,
                BUCode: this.currentBreadcrumbItem.BUCode,
                DirectoryName: this.currentBreadcrumbItem.DirectoryName,
                PackageId: this.currentBreadcrumbItem.PackageId,
              },
              bucketItemId
            );
          }
        });
        componentRef.instance.bucketItemId.subscribe((id: string) => {
          const found = this.bucketItems.find((t) => t.Id === id);
          if (found) found.ChecksumStatus = "VerifiedAndCorrupted";
        });
        break;

      case ComponentConstants.MOVE:
        if (this.bucketItems?.length === 0) {
          this.messageService.alert(
            ErrorConstants.SELECT_OR_CREATE_FOLDER,
            this.appSettingService.toastrDisplayTime
          );
        }
        componentRef =
          this.viewContainerRef.createComponent(MoveItemsComponent);
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));

        componentRef.instance.cancelTransfer.subscribe((result: boolean) => {
          if (result) {
            this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          }
        });
        componentRef.instance.requestObject.subscribe((request: any) => {
          this.router.navigate([`/buckets/bucketitem`], {
            queryParams: {
              bucketId: this.currentBreadcrumbItem.BucketId,
              bucketType: this.currentBreadcrumbItem.BucketType,
              buCode: this.currentBreadcrumbItem.BUCode,
              directoryName: request.selectedPath,
              packageId: request.destinationPackageId,
            },
          });
        });
        break;

      case ComponentConstants.DELETE_FOLDER:
        componentRef =
          this.viewContainerRef.createComponent(DeletePopupComponent);
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));

        componentRef.instance.cancelTransfer.subscribe((result: boolean) => {
          if (result) {
            this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          }
        });
        componentRef.instance.getAllBucketItemsRequest.subscribe(
          (request: IBucketItemRequest) => {
            this.dataService.setData(
              this.bucketItems.filter((t) => t.IsChecked)
            );
            this.getAllBucketItems(request);
          }
        );
        break;
      case ComponentConstants.FILE_VERSION_HISTORY:
        let clickedBucketItem = this.bucketItems.find(
          (x) => x.Id === this.clickedRow
        )
        if (!clickedBucketItem) {
          this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          this.messageService.alert(
            ErrorConstants.SELECT_FILE_FOR_VERSION_HISTORY,
            this.appSettingService.toastrDisplayTime
          );
          return;
        }
        const fileType = clickedBucketItem.Type;
        if ((fileType ?? '').toLowerCase() === "file") {
          componentRef = this.viewContainerRef.createComponent(
            FileVersionHistoryComponent
          );
        }
        else {
          this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
          this.messageService.alert(
            ErrorConstants.SELECT_FOLDER_FOR_FILE_VERSION,
            this.appSettingService.toastrDisplayTime
          );
        }
        break;
      case ComponentConstants.MULTIPLETAGS:
        componentRef = this.viewContainerRef.createComponent(
          MultipleTagsComponent
        );
        componentRef.instance.cancelMultitagsOperation.subscribe(
          (value: boolean) => {
            if (value) {
              this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
            }
          }
        );

        componentRef.instance.unSelectFoldersForMultipleTags.subscribe((request: boolean) => {
          if (request) {
            if (this.bucketItems && this.bucketItems.length > 0) {
              this.bucketItems.forEach((item) => {
                if (item.FolderType === "SubFolder" && item.IsChecked === true) {
                  item.IsChecked = false;
                }
              });
              this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
            }
          }
          this.checkedBucketItemsForMulipleTags = this.bucketItems.filter(x => x.IsChecked === true).map((x) => x.Id!);
        });

        componentRef.instance.tagsUpdated.subscribe((request: boolean) => {
          if (request) {
            this.uncheckAll(false);
            this.getAllBucketItems(
              {
                BucketId: this.currentBreadcrumbItem.BucketId,
                BucketType: this.currentBreadcrumbItem.BucketType,
                BUCode: this.currentBreadcrumbItem.BUCode,
                DirectoryName: this.currentBreadcrumbItem.DirectoryName,
                PackageId: this.currentBreadcrumbItem.PackageId,
              },
              undefined,
              true
            );
          }
        });

        break;

      case ComponentConstants.PACKAGE_FOLDER_TAGS:
        componentRef = this.viewContainerRef.createComponent(
          PackageFolderTagsComponent
        );
        componentRef.instance.cancelPackageFolderTagsOperation.subscribe(
          (value: boolean) => {
            if (value) {
              this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
            }
          }
        );

        componentRef.instance.tagsUpdated.subscribe((request: boolean) => {
          if (request) {
            this.uncheckAll(false);
            this.getAllBucketItems(
              {
                BucketId: this.currentBreadcrumbItem.BucketId,
                BucketType: this.currentBreadcrumbItem.BucketType,
                BUCode: this.currentBreadcrumbItem.BUCode,
                DirectoryName: this.currentBreadcrumbItem.DirectoryName,
                PackageId: this.currentBreadcrumbItem.PackageId,
              },
              undefined,
              true
            );
          }
        });

        break;
      default:
        break;
    }
  }

  onMoreClick(
    e: any,
    Id: string,
    select: boolean,
    name: string,
    type: string,
    BucketType: string,
    FolderType: string
  ) {
    e.preventDefault();
    let checkedPackageData = this.bucketItems.filter(
      (x) => x.IsChecked === true
    );
    let bucketIds = checkedPackageData.map((y) => y.Id);
    if (!bucketIds.includes(Id) || bucketIds.length === 0) {
      this.dataService.setDataForCheckBox(
        this.bucketItems.filter((x) => x.Id === Id)
      );
    }
    const isSingleSelection = !bucketIds.includes(Id) ? true : checkedPackageData.length === 1;
    this.singleSelection = isSingleSelection;
    this.multiSelection = !isSingleSelection;
    this.kebabContextItem = checkedPackageData.length === 0
      ? (this.bucketItems.find((x) => x.Id === Id) ?? null)
      : null;
    let types: string[] = [];
    types.push(type);
    this.resetActions();
    this.itemList = [];
    this.addActionsBasedOnItemType(types);
    if (select && checkedPackageData.length > 1) {
      this.itemList = this.itemList.filter((action) => action !== ActionConstants.TAGS);
    }
    const isSubfolder = (this.currentBreadcrumbItem?.DirectoryName?.split('/')?.length ?? 0) > 1;
    const isPackageFolder = type === 'Folder' &&
      (FolderType === 'StudyPackage' || FolderType === 'FacilityPackage');
    // Only show "Download Template" for single package folder selection
    if (isSubfolder && isPackageFolder && isSingleSelection) {
      this.itemList.push('Download Template');
    }
    let overlayPopupRef: OverlayPopupRef<ListOverlayComponent, unknown> | undefined;
    if (this.itemList.length > 0) {
      overlayPopupRef = this.overlayPopupService.open(ListOverlayComponent, {
        element: e,
        width: 160,
        displayPointer: false,
        data: this.itemList,
        offsetStartX: 140,
        offsetStartY: 10,
      });
    }
    this.selectedPackageData.LeafName = name;
    this.selectedPackageData.IsChecked = select;
    this.selectedPackageData.Type = type;
    this.selectedPackageData.Id = Id;
    this.selectedPackageData.BucketType = BucketType;
    overlayPopupRef?.afterClosed().subscribe((data) => {
      if (data === ActionConstants.TRANSFER) {
        this.loadDynamicComponent(ComponentConstants.TRANSFER_PACKAGE);

        if (
          this.selectedPackageData.IsChecked === undefined ||
          !this.selectedPackageData?.IsChecked
        ) {
          this.uncheckAll(false);
          this.selectedPackageData.IsChecked = true;
          this.bucketItems.filter(
            (item) => item.Id === this.selectedPackageData.Id
          )[0].IsChecked = true;
        }
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
      }
      else if (data === ComponentConstants.SHARE) {
        this.loadDynamicComponent(ComponentConstants.FOLDER_PERMISSION);
        if (!this.selectedPackageData?.IsChecked) {
          this.uncheckAll(false);
          this.selectedPackageData.IsChecked = true;
          this.bucketItems.filter(
            (item) => item.Id === this.selectedPackageData.Id
          )[0].IsChecked = true;
        }
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
      }
      else if (data === ActionConstants.DOWNLOAD) {
        this.downloadBucketItem();
      } else if (data === ActionConstants.EXPORT_CONTENT) {
        this.exportContentList();
      } else if (data === ActionConstants.RENAME) {
        this.renameFolderPopUp();

        if (
          this.selectedPackageData.IsChecked === undefined ||
          !this.selectedPackageData?.IsChecked
        ) {
          this.uncheckAll(false);
          this.selectedPackageData.IsChecked = true;
          this.bucketItems.filter(
            (item) => item.Id === this.selectedPackageData.Id
          )[0].IsChecked = true;
        }
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
      } else if (data === ActionConstants.MOVE) {
        this.openMoveItems();
      } else if (data === ActionConstants.EXPORT_AUDIT_TRAIL) {
        this.exportAuditTrailButton();
      } else if (data === ActionConstants.DELETE) {
        this.CheckForEmptyFolder();
        if (
          this.selectedPackageData.IsChecked === undefined ||
          !this.selectedPackageData?.IsChecked
        ) {
          this.uncheckAll(false);
          this.selectedPackageData.IsChecked = true;
          this.bucketItems.filter(
            (item) => item.Id === this.selectedPackageData.Id
          )[0].IsChecked = true;
        }
        this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
      } else if (data === ActionConstants.TAGS) {
        // Check if selected items are package folders
        const selectedItems = this.bucketItems.filter(x => x.IsChecked === true);
        const hasPackageFolders = selectedItems.some(item => 
          item.FolderType === 'StudyPackage' || item.FolderType === 'FacilityPackage'
        );
        const hasFiles = selectedItems.some(item => item.Type === 'File');
        
        if (hasPackageFolders && !hasFiles) {
          // Only package folders selected - use Package Folder Tags
          this.loadDynamicComponent(ComponentConstants.PACKAGE_FOLDER_TAGS);
        } else if (hasFiles) {
          // Files selected (with or without package folders) - use Multiple Tags
          this.loadDynamicComponent(ComponentConstants.MULTIPLETAGS);
        } else {
          // Only regular folders selected - show message
          this.messageService.alert("Tags can only be applied to files and package folders.");
        }
      } else if (data === 'Download Template') {
        this.downloadTemplate(this.selectedPackageData.Id!, false);
      }
    });
  }

  public rowMouseOver(row: any): void {
    this.hoverindex = row.Id;
  }

  public clickedRowData(row: Partial<IBucketItem>) {
    const selected = this.bucketItems.filter(x => x.IsChecked);
    const selectionCount = selected.length;
    // If there is at least one selection enforce rules.
    if (selectionCount === 1) {
      // Single selection: only allow highlight change to the selected row.
      if (!row.IsChecked) {
        return; // Ignore clicks on unselected rows (Req 2)
      }
    } else if (selectionCount > 1) {
      // Multi-selection: can only highlight inside selected rows.
      if (!row.IsChecked) {
        return; // Ignore
      }
    }
    // Either no selection OR row is part of selected set.
    if (this.clickedRow !== row.Id) {
      this.clickedRow = row.Id!;
      this.rowDataService.setclickedRowData(row);
      this.loadDynamicComponent(ComponentConstants.GENERAL_INFORMATION);
    }
  }

  public checkPackageFolder(): boolean {
    return (
      this.currentBreadcrumbItem &&
      (this.currentBreadcrumbItem.DirectoryName ?? '').split("/").length === 2 &&
      this.currentBreadcrumbItem.BucketType !==
      BucketTypeConstants.FACILITY_ARCHIVE
    );
  }

  public checkPackageFolderForFA(): boolean {
    return (
      this.currentBreadcrumbItem &&
      (this.currentBreadcrumbItem.DirectoryName ?? '').split("/").length === 2
    );
  }

  public addActionsBasedOnItemType(type: string[]): void {
    this.handleRenameAction(type);
    this.handleDownloadAction();
    this.handleTransferAction();
    this.handleMoveAction();
    this.handleDeleteAction(type);
    this.handleExportAuditTrailAction();
    this.handleTagsAction();
    this.handleFolderPermissionAction();
    this.handleExportContentAction();
  }

  public checkIfActionExists(operation: string): boolean {
    return this.itemList.length === 0 || !this.itemList?.includes(operation);
  }

  public handleRenameAction(type: string[]): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.RENAME_FOLDER_PERMISSION)
    );
    if (
      this.singleSelection &&
      type[0] === "Folder" &&
      permission &&
      this.currentBreadcrumbItem.BucketType !=
      BucketTypeConstants.FACILITY_ARCHIVE
    ) {
      if (this.checkIfActionExists(ActionConstants.RENAME)) {
        this.itemList.push(ActionConstants.RENAME);
      }
      this.displayRename = true;
    }
  }

  public handleDownloadAction(): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.DOWNLOAD)
    );
    if (
      (this.singleSelection ||
        (this.multiSelection && !this.checkPackageFolderForFA())) &&
      permission
    ) {
      if (this.checkIfActionExists(ActionConstants.DOWNLOAD)) {
        this.itemList.push(ActionConstants.DOWNLOAD);
      }
      this.displayDownload = true;
    }
  }

  public handleTransferAction(): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.TRANSFER)
    );
    if (
      !this.currentBreadcrumbItem.ParentId &&
      this.currentBreadcrumbItem.BucketType !==
      BucketTypeConstants.FACILITY_ARCHIVE
    ) {
      if (this.checkPackageFolder() && permission) {
        if (this.checkIfActionExists(ActionConstants.TRANSFER)) {
          this.itemList.push(ActionConstants.TRANSFER);
        }
        this.displayTransfer = true;
      }
    }
  }

  public handleMoveAction(): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.MOVE)
    );
    if (
      this.currentBreadcrumbItem.ParentId &&
      permission &&
      this.currentBreadcrumbItem.BucketType !=
      BucketTypeConstants.FACILITY_ARCHIVE
    ) {
      if (this.checkIfActionExists(ActionConstants.MOVE)) {
        this.itemList.push(ActionConstants.MOVE);
      }
      this.displayMove = true;
    }
  }

  public handleDeleteAction(type: string[]): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.DELETE_FOLDER_PERMISSION)
    );
    if (
      type[0] === "Folder" &&
      this.singleSelection &&
      permission &&
      this.currentBreadcrumbItem.BucketType !=
      BucketTypeConstants.FACILITY_ARCHIVE
    ) {
      if (this.checkIfActionExists(ActionConstants.DELETE)) {
        this.itemList.push(ActionConstants.DELETE);
      }
      this.displayDelete = true;
    }
  }

  public handleExportAuditTrailAction(): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.EXPORTAUDITTRAIL)
    );
    if (
      !this.currentBreadcrumbItem.ParentId &&
      this.singleSelection &&
      permission
    ) {
      if (this.checkIfActionExists(ActionConstants.EXPORT_AUDIT_TRAIL)) {
        this.itemList.push(ActionConstants.EXPORT_AUDIT_TRAIL);
      }
      this.displayExportAuditTrail = true;
    }
  }

  public handleTagsAction(): void {
    const hasTagPermission = this.permissionList.some((str) =>
      str.includes(ComponentConstants.UPDATETAG)
    );
    
    if (!hasTagPermission) {
      this.displayTags = false;
      return;
    }
    
    const checkedItems = this.bucketItems.filter(x => x.IsChecked === true);
    const selectedItems = checkedItems.length > 0
      ? checkedItems
      : (this.kebabContextItem ? [this.kebabContextItem] : []);
    let shouldShowTags = false;
    if (selectedItems.length > 0) {
      shouldShowTags = selectedItems.some(item => 
        item.Type === 'File' || 
        item.FolderType === FolderTypeConstants.STUDY_PACKAGE || 
        item.FolderType === FolderTypeConstants.FACILITY_PACKAGE
      );
    }
    
    this.displayTags = shouldShowTags;
    
    if (this.displayTags && this.checkIfActionExists(ActionConstants.TAGS)) {
      this.itemList.push(ActionConstants.TAGS);
    }
  }

  public handleGlobalTagsAction(): void {
    const selectedItems = this.bucketItems.filter(x => x.IsChecked === true);
    const hasPackageFolders = selectedItems.some(item => 
      item.FolderType === 'StudyPackage' || item.FolderType === 'FacilityPackage'
    );
    const hasFiles = selectedItems.some(item => item.Type === 'File');
    const hasRegularFolders = selectedItems.some(item => 
      item.Type === 'Folder' && item.FolderType === 'SubFolder'
    );
    
    if (hasPackageFolders && !hasFiles) {
      this.loadDynamicComponent(ComponentConstants.PACKAGE_FOLDER_TAGS);
    } else if (hasFiles) {
      this.loadDynamicComponent(ComponentConstants.MULTIPLETAGS);
    } else if (hasRegularFolders && !hasPackageFolders && !hasFiles) {
      this.messageService.alert("Tags can only be applied to files and package folders.");
    } else {
      this.messageService.alert("Tags can only be applied to files and package folders.");
    }
  }

  public handleFolderPermissionAction(): void {
    let permission = this.permissionList.some((str) =>
      str.includes(ActionConstants.FOLDER_PERMISSION)
    );
    if (!this.currentBreadcrumbItem.ParentId &&
      this.currentBreadcrumbItem.BucketType === BucketTypeConstants.FACILITY_ARCHIVE &&
      permission &&
      this.singleSelection &&
      this.checkIfActionExists(ActionConstants.FOLDER_PERMISSION)) {
      this.itemList.push(ComponentConstants.SHARE);
      this.displayFolderPermission = true;
    }
  }

  public handleExportContentAction(): void {
    if (!this.currentBreadcrumbItem.ParentId &&
      (this.currentBreadcrumbItem.BucketType === BucketTypeConstants.FACILITY_ARCHIVE || this.currentBreadcrumbItem.BucketType === BucketTypeConstants.PREARCHIVE) &&
      this.singleSelection && this.checkIfActionExists(ActionConstants.EXPORT_CONTENT)) {
      this.itemList.push(ActionConstants.EXPORT_CONTENT);
      this.displayExportContent = true;
    }
  }

  public resetActions(): void {
    this.displayDelete = false;
    this.displayDownload = false;
    this.displayTransfer = false;
    this.displayFolderPermission = false;
    this.displayExportContent = false;
    this.displayExportAuditTrail = false;
    this.displayMove = false;
    this.displayRename = false;
    this.displayTags = false;
  }

  public renameFolderPopUp(): void {
    this.dataService
      .getAllSelectedData()
      .pipe(take(1))
      .subscribe((data: Partial<IBucketItem>[]) => {
        if (data) {
          this.selectedBucketItems = data;
        }
      });
    this.renameFolderPopup = {
      SelectedBucketItems: this.selectedBucketItems,
      CurrentBreadcrumbItem: this.currentBreadcrumbItem,
    };

    let dialogRef = this.dialog.open(RenamePopupComponent, {
      width: "529px",
      maxHeight: "500px",
      data: this.renameFolderPopup,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllBucketItems(
          {
            BucketId: this.currentBreadcrumbItem.BucketId,
            BucketType: this.currentBreadcrumbItem.BucketType,
            BUCode: this.currentBreadcrumbItem.BUCode,
            DirectoryName: this.currentBreadcrumbItem.DirectoryName,
            PackageId: this.currentBreadcrumbItem.PackageId,
          },
          undefined,
          true
        );
      }
    });
  }

  openMoveItems() {
    this.loadDynamicComponent(ComponentConstants.MOVE);
    this.dataService.setData(this.bucketItems.filter((t) => t.IsChecked));
  }

  public exportAuditTrailButton(): void {
    this.spinnerService.show(true);

    this.dataService
      .getAllSelectedData()
      .pipe(take(1))
      .subscribe((data: Partial<IBucketItem>[]) => {
        if (data) {
          this.selectedBucketItems = data;
        }
      });

    this.bucketItemsService
      .IsGreaterThanMillionEntries(
        this.selectedBucketItems[0].Id!,
        this.selectedBucketItems[0].PackageId!
      )
      .pipe(
        map((data: boolean) => {
          this.spinnerService.show(false);

          if (data) {
            this.messageService
              .confirm(
                "Only the last 1 million entries will be exported. Please contact eLIMS support team to export all audit trail records of selected package.",
                "Do you want to export audit trail?",
                "Yes",
                "No"
              )
              .subscribe((result: any) => {
                if (result === true) {
                  this.exportAuditTrail();
                }
              });
          } else {
            this.exportAuditTrail();
          }
        }),
        catchError(async (error: HttpErrorResponse) => {
          this.spinnerService.show(false);
          const errorMessage = JSON.parse(await error.error.text());
          if (errorMessage.detail) {
            this.messageService.alert(
              errorMessage.detail,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            this.messageService.alert(
              ErrorConstants.EXPORT_AUIDT_TRAIL_FAILED,
              this.appSettingService.toastrDisplayTime
            );
          }
          return throwError(() => new Error(error.message));
        })
      )
      .subscribe();
  }

  private exportAuditTrail(): void {
    this.spinnerService.show(true);
    this.bucketItemsService
      .exportAuditTrail(
        this.selectedBucketItems[0].Id!,
        this.selectedBucketItems[0].PackageId!,
        ' dd MMM yyyy HH:mm:ss '
      )
      .pipe(
        map((data: any) => {
          if (data) {
            const contentDisposition = data.headers.get("Content-Disposition");
            let filename =
              this.getFilenameFromContentDisposition(contentDisposition ?? '');
            filename = this.genericExtensions.extractBase64AndDecode(filename);
            const blob = new Blob([data.body], {
              type: "application/zip",
            });
            const a: any = this._document.createElement("a");
            const url = this._document.defaultView!.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            this._document.defaultView!.URL.revokeObjectURL(url);
            this.spinnerService.show(false);
          }
        }),
        catchError(async (error: HttpErrorResponse) => {
          this.spinnerService.show(false);
          const errorMessage = JSON.parse(await error.error.text());
          if (errorMessage.detail) {
            this.messageService.alert(
              errorMessage.detail,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            this.messageService.alert(
              ErrorConstants.EXPORT_AUIDT_TRAIL_FAILED,
              this.appSettingService.toastrDisplayTime
            );
          }
          return throwError(() => new Error(error.message));
        })
      )
      .subscribe();
  }
  public exportContentList(): void {
    this.spinnerService.show(true);
    this.exportContent.BucketId = this.currentBreadcrumbItem.BucketId;
    this.exportContent.BucketType = this.currentBreadcrumbItem.BucketType;
    this.exportContent.BuCode = this.currentBreadcrumbItem.BUCode;
    this.exportContent.BuName = this.currentBreadcrumbItem.EleName;

    this.bucketItems
      .filter((t) => t.IsChecked)
      .forEach((a) => {
        this.exportContent.BucketItemId = a.Id;
        this.exportContent.PackageId = a.PackageId;
      });
    this.bucketItemsService
      .exportContentList(this.exportContent)
      .pipe(
        map((data: HttpResponse<Blob>) => {
          if (data) {
            const contentDisposition = data.headers.get("Content-Disposition") ?? '';
            const filename =
              this.getFilenameFromContentDisposition(contentDisposition);
            const blob = new Blob([data.body!], {
              type: "application/pdf",
            });
            const a: HTMLAnchorElement = this._document.createElement("a");
            const url = this._document.defaultView!.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            this._document.defaultView!.URL.revokeObjectURL(url);
          }
        }),
        catchError(async (error: HttpErrorResponse) => {
          const errorMessage = JSON.parse(await error.error.text());
          if (errorMessage.dataServiceetail) {
            this.messageService.alert(
              errorMessage.detail,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            this.messageService.alert(
              ErrorConstants.EXPORT_CONTENT_FAILED,
              this.appSettingService.toastrDisplayTime
            );
          }
          return throwError(() => new Error(error.message));
        }),
        finalize(() => {
          this.spinnerService.show(false);
        })
      )
      .subscribe();
  }

  public CheckForEmptyFolder(): void {
    this.dataService
      .getAllSelectedData()
      .pipe(take(1))
      .subscribe((data: Partial<IBucketItem>[]) => {
        if (data) {
          this.selectedBucketItems = data;
        }
      });
    this.deleteFolderPopup = {
      SelectedBucketItems: this.selectedBucketItems,
      CurrentBreadcrumbItem: this.currentBreadcrumbItem,
    };
    this.bucketItemsService
      .CheckChildItemsCount(
        this.selectedBucketItems[0].Id!,
        this.selectedBucketItems[0].PackageId!
      )
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.messageService.alert(
              ErrorConstants.ONLY_EMPTY_FOLDERS_CAN_BE_DELETED,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            let dialogRef = this.dialog.open(DeletePopupComponent, {
              width: "529px",
              maxHeight: "500px",
              disableClose: true,
              data: this.deleteFolderPopup,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                setTimeout(() => {
                  this.getAllBucketItems(
                    {
                      BucketId: this.currentBreadcrumbItem.BucketId,
                      BucketType: this.currentBreadcrumbItem.BucketType,
                      BUCode: this.currentBreadcrumbItem.BUCode,
                      DirectoryName: this.currentBreadcrumbItem.DirectoryName,
                      PackageId: this.currentBreadcrumbItem.PackageId,
                    },
                    undefined,
                    true
                  );
                }, 200);
              }
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.error.detail) {
            this.messageService.alert(
              error.error.detail,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            this.messageService.alert(
              error.error.message,
              this.appSettingService.toastrDisplayTime
            );
          }
          this.spinnerService.show(false);
        },
      });
  }
  public openMoreTagsOverlay(e: any, tags: Partial<ITags>[]) {
    const tagValues = tags.reduce((val: string[], tag) => {
      return tag.TagValue ? [...val, tag.TagValue] : val;
    }, []);

    this.overlayPopupService.open(ListOverlayComponent, {
      data: tagValues,
      element: e,
      offsetStartY: 10,
    });
  }

  openSearch() {
    this.isSearchable = !this.isSearchable;
    if (this.searchComponent.toDisplay && !this.isSearchable) {
      this.searchExpand = false;
    }
    else if (this.searchComponent.toDisplay && this.isSearchable) {
      this.searchExpand = true;
    }
    if (this.isSearchable) {
      this.dataService.setSearchBarStatus(this.searchExpand ? 3 : 2);
      this._document.getElementById('bucket-items-list-cmp-search')!.style.display = 'block';
    }
    else {
      this.dataService.setSearchBarStatus(1);
      this._document.getElementById('bucket-items-list-cmp-search')!.style.display = 'none';
    }
  }

  onSearch(SearchDetails: Partial<ISearchRequest>) {
    this.searchRequest = SearchDetails;
    if (SearchDetails.ArchivingStartDate || SearchDetails.ArchivingEndDate) {
      this.searchRequest.ArchivingStartDate = this.convert(SearchDetails.ArchivingStartDate);
      this.searchRequest.ArchivingEndDate = this.convert(SearchDetails.ArchivingEndDate);
    }
    if (SearchDetails.StudyCompletionStartDate || SearchDetails.StudyCompletionEndDate) {
      this.searchRequest.StudyCompletionStartDate = this.convert(SearchDetails.StudyCompletionStartDate);
      this.searchRequest.StudyCompletionEndDate = this.convert(SearchDetails.StudyCompletionEndDate);
    }
    if (SearchDetails.CreatedStartDate || SearchDetails.CreatedEndDate) {
      this.searchRequest.CreatedStartDate = this.convert(SearchDetails.CreatedStartDate);
      this.searchRequest.CreatedEndDate = this.convert(SearchDetails.CreatedEndDate);
    }
    this.searchRequest.DirName = this.currentBreadcrumbItem.DirectoryName;
    if (this.currentBreadcrumbItem.PackageId !== undefined) {
      this.searchRequest.PackageId = this.currentBreadcrumbItem.PackageId;
    }
    this.pageNumber = 1;
    this.search(this.pageNumber);
  }

  public convert(str: string | undefined): string | undefined {
    if (str) {
      const date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [day, mnth, date.getFullYear()].join("-");
    }
    return undefined;
  }

  public onClearSearch(event: Event): void {
    this.addPendingOperation('clearSearch');
    this.searchComponent.onClearSearchClick();
    this.searchComponent.clearYearOfEntry(event);
    setTimeout(() => this.completePendingOperation('clearSearch'));
  }

  /**
   * Called by `LazyScrollDirective` via `(nearEnd)` once the user reaches
   * the 60 % scroll threshold.  Guards against concurrent fetches via
   * `pendingOperations` and branches on search-vs-browse context.
   */
  public handleLazyLoad(): void {
    if (this.pendingOperations.size > 0) return;

    if (this.IsSearched) {
      if (this.pageNumber < (this.searchResults.TotalPages ?? 0)) {
        this.pageNumber++;
        this.search(this.pageNumber);
      }
    } else {
      if (this.browsePageNumber < this.browseTotalPages) {
        this.browsePageNumber++;
        this.getAllBucketItems(this.currentBrowseRequest, undefined, false, this.browsePageNumber);
      }
    }
  }

  public sort(sortData: ISortParameters) {
    this.searchRequest.Sort = sortData;
    this.pageNumber = 1;
    this.search(1);
  }

private search(pageNumber: number): void {
    this.searchTrigger$.next(pageNumber);
    this.searchComponent.markBucketAsUntouched();
  }

  private executeSearch(pageNumber: number): Observable<void> {
    if (pageNumber === 0) {
      return EMPTY;
    }
    this.setAll(false);
    if (pageNumber === 1) {
      this.bucketItems = [];
      this._document.getElementById('bucket-items-list-cnt-virtual-scroll')?.scrollTo({ top: 0 });
      this.searchResetCounter++;
      this.addPendingOperation('search');
    } else {
      this.pendingOperations.add('search');
    }
    this.searchRequest.PageNumber = pageNumber;

    return this.bucketItemsService.Search(this.searchRequest).pipe(
      map((res: Partial<ISearchResultsResponse>) => {
        if (res && res.BucketItems !== undefined) {

          this.searchResults = res;

          const allItemsArePackageFolders = res.BucketItems?.every(
            item =>
              item.Type === 'Folder' &&
              (item.FolderType === FolderTypeConstants.STUDY_PACKAGE ||
               item.FolderType === FolderTypeConstants.FACILITY_PACKAGE)
          ) ?? false;

          this.IsSearched = true;

          this.isOnlyPackageFolders = allItemsArePackageFolders;

          this.count = res.TotalCount || 0;

          if (pageNumber === 1) {
            this.bucketItems = res.BucketItems || [];
          } else {
            this.bucketItems = [...this.bucketItems, ...(res.BucketItems || [])];
          }

          this.bucketItems.forEach((bucketItem) => {
            bucketItem.TagsWithValues = bucketItem.Tags
              ? bucketItem.Tags.filter(x => x.TagValue !== "")
              : [];
          });

        } else {
          this.IsSearched = false;
          this.isOnlyPackageFolders = false;
          this.bucketItems = this.displayBucketItems;
          this.count = this.displayBucketItems.length;
        }
        this.completePendingOperation('search');
      }),
      catchError((error: HttpErrorResponse) => {
        this.completePendingOperation('search');
        if (error?.error?.detail !== undefined) {
          this.messageService.alert(
            error.error.detail,
            this.appSettingService.toastrDisplayTime
          );
        } else {
          this.messageService.alert(
            "Search Failed",
            this.appSettingService.toastrDisplayTime
          );
        }
        return EMPTY;
      })
    );
  }

  searchExpandedFlag(event: boolean) {
    this.searchExpand = event;
    this.dataService.setSearchBarStatus(this.searchExpand ? 3 : 2);
  }

  showInformation(event: Event, item: Partial<IBucketItem>, forLockedOverlay: boolean) {
    let userInfo: IUserInformation = {
      Name: item.FullName!,
      Email: item.EmailId!,
      IsActiveUser: item.IsActiveUser!,
      PUID: item.CreatedBy,
      ForLockedOverlay: forLockedOverlay
    };
    if (forLockedOverlay) {
      userInfo = {
        Name: item.LockedByFullName!,
        Email: item.LockedByEmail!,
        IsActiveUser: item.LockedByIsActive!,
        PUID: item.LockedBy,
        ForLockedOverlay: forLockedOverlay
      }
    }
    this.dataService.setUserInformation(userInfo);
    this.genericExtensions.onInfoClick(event, userInfo);
  }

  public downloadTemplate(bucketOrTemplateId: string, isTemplateId: boolean = true): void {
    this.spinnerService.show(true);
    this.bucketItemsService.downloadTemplate(bucketOrTemplateId, isTemplateId).subscribe({
      next: (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get("Content-Disposition") ?? '';
        const filename = this.getFilenameFromContentDisposition(contentDisposition);
        const blob = new Blob([response.body!], { type: "application/zip" });
        const url = this._document.defaultView!.URL.createObjectURL(blob);
        const a = this._document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        this._document.defaultView!.URL.revokeObjectURL(url);
        this.spinnerService.show(false);
      },
      error: async (error: HttpErrorResponse) => {
        let errorMessage = "Failed to download template";
        try {
          const errorText = await error.error.text();
          const errorBody = JSON.parse(errorText);
          if (errorBody?.detail) {
            errorMessage = errorBody.detail;
          }
        } catch (parseError) {
          if (error.message) {
            errorMessage = error.message;
          }
        }
        this.messageService.alert(errorMessage, this.appSettingService.toastrDisplayTime);
        this.spinnerService.show(false);
      }
    });
  }

  private blobToJson(blob: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          resolve(JSON.parse(reader.result as string));
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsText(blob);
    });
  }

  public buildListControlId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join("-");
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === "number") {
      return value.toString().padStart(2, "0");
    }
    if (typeof value === "string" && value.trim().length > 0) {
      return this.slugify(value);
    }
    return "00";
  }

  private slugify(value: string): string {
    return (value || "na")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-{2,}/g, "-");
  }

}
